// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inner[data-v-78cc0153]{text-align:center}.inner[data-v-78cc0153]  .btn-general{margin-bottom:5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
